import { useState, useContext, createContext, useMemo, useEffect } from "react";
import {
  Button,
  TextField,
  IconButton,
  MenuItem,
  Modal,
  InputAdornment,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { Context } from "../DashCrearSolicitudCredito";
import Swal from "sweetalert2";
import CallIcon from "@mui/icons-material/Call";
import request from "../../../../../Helpers/API";
import { ValTextAndNumber } from "../../../../../Validators/ValTextAndNumber";
import { ValIsEmail } from "../../../../../Validators/ValIsEmail";
import { ValOnlyNumber } from "../../../../../Validators/ValOnlyNumber";
import { ValFormReg } from "../../../../../Validators/ValForms";
import { RegularExpressions } from "../../../../../Helpers/RegularExpression";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { ValSpecialCharacters } from "../../../../../Validators/ValSpecialCharacters";

const contextContactos = createContext(null);

export default function SolicitudDecreditoContacto({
  screen,
  setScreen,
  setValue,
  setBotonSiguiente,
}) {
  const { state, setState } = useContext(Context);
  const [datoscontacto, setDatosContacto] = useState([]);
  const [stateContactos, setStateContactos] = useState({
    open: false,
  });
  const openModal = () => {
    setStateContactos({
      ...stateContactos,
      open: true,
      orden: -1,
      medio_contacto: "",
      tipo_contacto: "",
      valor: "",
      comentarios: "",
      bmedio_contacto: false,
      btipo_contacto: false,
      bvalor: false,
      bcomentarios: false,
      estatus: 1,
      recargar: true,
    });
  };

  const openEditarContacto = (contacto) => {
    setStateContactos({
      ...stateContactos,
      open: true,
      medio_contacto: contacto.medio_contacto.substring(0, 1),
      tipo_contacto: contacto.tipo_contacto.substring(0, 2),
      valor: contacto.valor,
      comentarios: contacto.comentarios,
      orden: contacto.orden,
      recargar: false,
      folio: state.folio,
    });
  };
  const contextValue = useMemo(
    () => ({
      stateContactos,
      setStateContactos,
    }),
    [stateContactos, setStateContactos]
  );
  useEffect(() => {
    setBotonSiguiente(() => (
      <div
        className="footer-solicitud-credito-guardar"
        onClick={() => Number(screen) >= 0 && setValue(2)}
      >
        Siguiente <ArrowForwardIcon />
      </div>
    ));
  }, []);
  useEffect(() => {
    // setLoader({ ...loader, mostrar: true });
    request
      .get(`ClientesDatosContacto/Listado?idcliente=${state.idCliente}`)
      .then((result) => {
        setDatosContacto(result);
        // setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire({
          icon: "error",
          title: "SOLICITUD DE CREDITO",
          text: `${JSON.stringify(error)}`,
        });
      });
  }, []);
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 
  return (
    <contextContactos.Provider value={contextValue}>
      <div className="solicitud-container">
        <Button
          startIcon={<AddIcon />}
          onClick={openModal}
          variant="contained"
          fullWidth
          style={{ marginBottom: 10 }}
        >
          Agregar Contacto
        </Button>

        <ModalAgregar
          setDatosContacto={setDatosContacto}
          // loader={loader}
          // setLoader={setLoader}
          screen={screen}
          setScreen={setScreen}
        />
        <div className="dash-clientes-container-table-contactos scroll">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Medio de Contacto</th>
                <th>Contacto</th>
                <th>Dato</th>
                <th>Comentarios</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {datoscontacto === undefined ||
              datoscontacto === null ||
              datoscontacto.length === 0 ? (
                <>Sin datos</>
              ) : (
                datoscontacto.map((contacto, i) => (
                  <tr>
                    <td>{capitalizeWords(contacto.medio_contacto)}</td>
                    <td>{capitalizeWords(contacto.tipo_contacto)}</td>
                    <td>{contacto.valor}</td>
                    <td>{contacto.comentarios}</td>
                    <td>
                      <IconButton
                        color="warning"
                        onClick={() => {
                          openEditarContacto(contacto);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </contextContactos.Provider>
  );
}

// Componente para el modal de agregar un nuevo cultivo
function ModalAgregar({ setDatosContacto, screen, setScreen }) {
  // Utilizamos el contexto de los cultivos y de la solicitud de crédito
  const { stateContactos, setStateContactos } = useContext(contextContactos);
  const { state } = useContext(Context);
  // Función para cerrar el modal
  const closeModal = () => {
    setStateContactos({
      ...stateContactos,
      open: false,
    });
  };
  // const [stateContactos, setFormDatos] = useState({
  //   medio_contacto: stateContactos.medio_contacto,
  //   tipo_contacto:
  //     stateContactos.tipo_contacto === undefined ||
  //     stateContactos.tipo_contacto === null
  //       ? ""
  //       : stateContactos.tipo_contacto.toUpperCase(),
  //   valor: stateContactos.valor,
  //   comentarios: stateContactos.comentarios,
  //   bmedio_contacto: false,
  //   btipo_contacto: false,
  //   bvalor: false,
  //   bcomentarios: false,
  //   estatus: 1,
  //   orden: -1,
  // });
  // Función para recargar la tabla de cultivos
  const recargarTablaContactos = () => {
    request
      .get(`ClientesDatosContacto/Listado?idcliente=${state.idCliente}`)
      .then((result) => {
        setDatosContacto(result);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "SOLICITUD DE CREDITO",
          text: `${JSON.stringify(error)}`,
        });
      });
  };

  // Función para agregar un nuevo cultivo
  const agregarContacto = (datos) => {
    // setLoader({ ...loader, mostrar: true });
    // Validar los campos utilizando las funciones de validación
    const medioContactoValidation = ValFormReg(
      "Medio de contacto",
      datos.medio_contacto,
      RegularExpressions.TextWithSpace
    );
    const tipoContactoValidation = ValFormReg(
      "Tipo de contacto",
      datos.tipo_contacto,
      RegularExpressions.TextWithSpace
    );
    let valorValidation;
    if (datos.medio_contacto === "C") {
      valorValidation = ValFormReg(
        "Correo electrónico",
        datos.valor,
        RegularExpressions.TextEmail
      );
    } else {
      valorValidation = ValFormReg(
        "Número telefónico",
        datos.valor,
        RegularExpressions.TextOnlyNumber
      );
    }
    const comentariosValidation = ValFormReg(
      "Comentarios",
      datos.comentarios,
      RegularExpressions.TextSpecialCharacter
    );

    // Verificar si alguna validación falla
    if (
      !medioContactoValidation.isValid ||
      !tipoContactoValidation.isValid ||
      !valorValidation.isValid ||
      !comentariosValidation.isValid
    ) {
      // setLoader({ ...loader, mostrar: false });
      // Mostrar mensajes de error
      Swal.fire({
        icon: "error",
        title: "Error de validación",
        html: `
          ${medioContactoValidation.mensaje}
          ${tipoContactoValidation.mensaje}
          ${valorValidation.mensaje}
          ${comentariosValidation.mensaje}
        `,
      });
      return; // Detener la función si hay errores de validación
    }
    if (
      stateContactos.medio_contacto !== "C" &&
      stateContactos.valor.length !== 10
    ) {
      // setLoader({ ...loader, mostrar: false });
      Swal.fire(
        "SOLICITUD DE CREDITO",
        "El campo de numero de telefono debe contener 10 numeros",
        "error"
      );
      return;
    }
    datos.idcliente = state.idCliente;
    datos.orden = stateContactos.orden;
    request
      .post("ClientesDatosContacto", datos)
      .then(() => {
        recargarTablaContactos();
      })
      .then(() => {
        // setLoader({ ...loader, mostrar: false });
        closeModal();
        var habScreen = Number(screen) >= 2 ? screen : 1;
        setScreen(habScreen);
        Swal.fire({
          title: "Datos guardados",
          icon: "success",
        });
      })
      .catch((error) => {
        Swal.fire("SOLICITUD DE CREDITO", JSON.stringify(error), "error");
      });
  };

  // Función para actualizar un campo del formulario
  const actualizarCampo = ({ target }) => {
    setStateContactos({
      ...stateContactos,
      [target.name]: target.value,
      ["b" + target.name]: false,
      recargar: true,
    });
  };
  const onChange = (prop, value, sbool, smensaje) => {
    setStateContactos({
      ...stateContactos,
      [prop]: value,
      ["b" + prop]: false,
    });
  };
  useEffect(() => {
    if (stateContactos.recargar === true)
      setStateContactos({
        ...stateContactos,
        valor: "",
      });
    else
      setStateContactos({
        ...stateContactos,
        recargar: true,
      });
  }, [stateContactos.medio_contacto]);
  // Renderizado del componente
  return (
    <Modal open={stateContactos.open} className="position-z-index">
      <div className="dash-clientes-credito-crear-solicitud-modal">
        <div className="dash-clientes-credito-crear-solicitud-modal-header">
          <div className="dash-clientes-credito-crear-solicitud-modal-header-title">
            <CallIcon />
            <div>
              {stateContactos.orden === -1 ? "AGREGAR NUEVO " : "EDITAR "}
              CONTACTO
            </div>
          </div>
          <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto">
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-bl"></div>
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-circle"></div>
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-br"></div>
          </div>
        </div>
        <div className="dash-clientes-credito-crear-solicitud-form-container">
          <div className="mid">
            <TextField
              fullWidth
              size="small"
              label="Medio de Contacto"
              variant="outlined"
              name="medio_contacto"
              select
              error={stateContactos.bmedio_contacto}
              onChange={actualizarCampo}
              value={stateContactos.medio_contacto}
            >
              <MenuItem value={"W"}>WHATSAPP</MenuItem>
              <MenuItem value={"T"}>TELEFONO</MenuItem>
              <MenuItem value={"C"}>CORREO ELECTRONICO</MenuItem>
            </TextField>
            <TextField
              fullWidth
              size="small"
              label="Tipo de Contacto"
              variant="outlined"
              name="tipo_contacto"
              select
              error={stateContactos.btipo_contacto}
              onChange={actualizarCampo}
              value={stateContactos.tipo_contacto}
            >
              <MenuItem value={"CO"}>COBRANZA</MenuItem>
              <MenuItem value={"VE"}>VENDEDOR</MenuItem>
            </TextField>
          </div>
          <div className="full">
            {stateContactos.medio_contacto === "C" ? (
              <TextField
                fullWidth
                size="small"
                label="Correo Electronico"
                type={"text"}
                name="valor"
                error={stateContactos.bvalor}
                onChange={({ target }) => {
                  ValIsEmail("valor", target.value, onChange);
                }}
                value={stateContactos.valor}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MarkunreadIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            ) : (
              <TextField
                fullWidth
                size="small"
                label={"Numero Telefonico"}
                type={"number"}
                name="valor"
                error={stateContactos.bvalor}
                onChange={({ target }) => {
                  ValOnlyNumber("valor", target.value, onChange, true, 10);
                }}
                value={stateContactos.valor}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CallIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </div>
          <div className="full">
            <TextField
              fullWidth
              label="Comentarios"
              name="comentarios"
              multiline
              error={stateContactos.bcomentarios}
              rows={3}
              onChange={({ target }) => {
                ValSpecialCharacters(
                  "comentarios",
                  target.value,
                  onChange,
                  true,
                  500
                );
              }}
              value={stateContactos.comentarios}
            />
          </div>
          <div className="mid dash-clientes-credito-crear-solicitud-modal-button-container">
            <Button onClick={closeModal} variant="contained" color="error">
              Cerrar
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                agregarContacto(stateContactos);
              }}
            >
              {stateContactos.orden === -1 ? "Agregar" : "Editar"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
